import React, { useState } from 'react';
const INGREDIENTS = [{
  name: 'Avena instantánea',
  qty: 40,
  unit: 'g',
  basePrice: 450
}, {
  name: 'Maní pelado s/sal',
  qty: 20,
  unit: 'g',
  basePrice: 600
}, {
  name: 'Proteína / Albúmina',
  qty: 20,
  unit: 'g',
  basePrice: 1200
}, {
  name: 'Edulcorante + Coco',
  qty: 5,
  unit: 'g',
  basePrice: 200
}];
const CHANNELS = [{
  id: 'super',
  label: 'Supermercado',
  multiplier: 1.0
}, {
  id: 'diet_barrio',
  label: 'Dietética barrio',
  multiplier: 0.75
}, {
  id: 'diet_granel',
  label: 'Dietética a granel',
  multiplier: 0.45
}, {
  id: 'mayorista',
  label: 'Mayorista',
  multiplier: 0.33
}];
function fmt(n: number): string {
  return n.toLocaleString('es-AR', {
    maximumFractionDigits: 0
  });
}
export function SavingsCalculator() {
  const [barsPerDay, setBarsPerDay] = useState(2);
  const [daysPerMonth, setDaysPerMonth] = useState(25);
  const [channelId, setChannelId] = useState('mayorista');
  const activeChannel = CHANNELS.find(c => c.id === channelId) || CHANNELS[0];
  const mult = activeChannel.multiplier;
  const baseTotalPerBar = INGREDIENTS.reduce((acc, ing) => acc + ing.basePrice, 0);
  const selectedTotalPerBar = baseTotalPerBar * mult;
  const savingsPerBar = baseTotalPerBar - selectedTotalPerBar;
  const discountPct = Math.round((1 - mult) * 100);
  const totalBarsPerMonth = barsPerDay * daysPerMonth;
  const monthlySavings = savingsPerBar * totalBarsPerMonth;
  return <section className="bg-white py-12 sm:py-20 px-4 border-t border-[#E2E8F0]" data-id="element-223">
      <div className="max-w-[780px] mx-auto" data-id="element-224">
        <div className="w-12 h-1 bg-gradient-to-r from-[#15803D] to-[#22C55E] rounded-sm mx-auto mb-5" data-id="element-225" />

        <h2 className="font-montserrat text-[clamp(22px,3.5vw,32px)] font-extrabold text-center mb-[10px] text-[#0F172A] tracking-tight leading-[1.2]" data-id="element-226">
          Calculadora de Ahorro Mayorista
        </h2>
        <p className="text-center text-[#475569] text-[15px] mb-10 max-w-[600px] mx-auto" data-id="element-227">
          Descubrí cuánta plata estás perdiendo en el supermercado y cuánto
          podés ahorrar aplicando el Método Barrita Pro.
        </p>

        <div className="bg-white border border-[#E2E8F0] rounded-2xl shadow-sm p-6 sm:p-8 mb-8" data-id="element-228">
          {/* Controls */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-229">
            <div data-id="element-230">
              <label className="flex justify-between font-montserrat text-[13px] font-bold text-[#0F172A] uppercase tracking-wide mb-3" data-id="element-231">
                <span data-id="element-232">Barritas por día</span>
                <span className="text-[#2563EB]" data-id="element-233">{barsPerDay}</span>
              </label>
              <input type="range" min="1" max="4" value={barsPerDay} onChange={e => setBarsPerDay(Number(e.target.value))} className="w-full h-2 bg-[#E2E8F0] rounded-lg appearance-none cursor-pointer accent-[#2563EB]" data-id="element-234" />
            </div>
            <div data-id="element-235">
              <label className="flex justify-between font-montserrat text-[13px] font-bold text-[#0F172A] uppercase tracking-wide mb-3" data-id="element-236">
                <span data-id="element-237">Días por mes</span>
                <span className="text-[#2563EB]" data-id="element-238">{daysPerMonth}</span>
              </label>
              <input type="range" min="10" max="31" value={daysPerMonth} onChange={e => setDaysPerMonth(Number(e.target.value))} className="w-full h-2 bg-[#E2E8F0] rounded-lg appearance-none cursor-pointer accent-[#2563EB]" data-id="element-239" />
            </div>
          </div>

          {/* Channel Selector */}
          <div className="mb-8" data-id="element-240">
            <p className="font-montserrat text-[13px] font-bold text-[#0F172A] uppercase tracking-wide mb-3" data-id="element-241">
              ¿Dónde comprás los ingredientes?
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2" data-id="element-242">
              {CHANNELS.map(c => <button key={c.id} onClick={() => setChannelId(c.id)} className={`py-2.5 px-2 text-[13px] font-semibold rounded-lg border transition-all duration-200 ${channelId === c.id ? 'bg-[#0F172A] border-[#0F172A] text-white' : 'bg-white border-[#CBD5E1] text-[#475569] hover:border-[#94A3B8]'}`} data-id="element-243">
                  {c.label}
                </button>)}
            </div>
          </div>

          {/* Metrics Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8" data-id="element-244">
            <div className="bg-[#F8FAFC] border border-[#E2E8F0] rounded-xl p-4 text-center" data-id="element-245">
              <p className="text-[11px] text-[#64748B] font-bold uppercase tracking-wider mb-1" data-id="element-246">
                Costo Super
              </p>
              <p className="font-montserrat text-xl font-bold text-[#DC2626]" data-id="element-247">
                ${fmt(baseTotalPerBar)}
              </p>
            </div>
            <div className="bg-[#F8FAFC] border border-[#E2E8F0] rounded-xl p-4 text-center" data-id="element-248">
              <p className="text-[11px] text-[#64748B] font-bold uppercase tracking-wider mb-1" data-id="element-249">
                Costo Actual
              </p>
              <p className="font-montserrat text-xl font-bold text-[#0F172A]" data-id="element-250">
                ${fmt(selectedTotalPerBar)}
              </p>
            </div>
            <div className="bg-[#F0FDF4] border border-[#bbf7d0] rounded-xl p-4 text-center" data-id="element-251">
              <p className="text-[11px] text-[#166534] font-bold uppercase tracking-wider mb-1" data-id="element-252">
                Ahorro / Barrita
              </p>
              <p className="font-montserrat text-xl font-bold text-[#15803D]" data-id="element-253">
                ${fmt(savingsPerBar)}
              </p>
            </div>
            <div className="bg-[#F0FDF4] border border-[#bbf7d0] rounded-xl p-4 text-center" data-id="element-254">
              <p className="text-[11px] text-[#166534] font-bold uppercase tracking-wider mb-1" data-id="element-255">
                Descuento
              </p>
              <p className="font-montserrat text-xl font-bold text-[#15803D]" data-id="element-256">
                {discountPct}%
              </p>
            </div>
          </div>

          {/* Progress Bar */}
          <div className="mb-8" data-id="element-257">
            <div className="flex justify-between text-[12px] font-bold text-[#475569] mb-2" data-id="element-258">
              <span data-id="element-259">Precio Supermercado (100%)</span>
              <span className="text-[#15803D]" data-id="element-260">Ahorro: {discountPct}%</span>
            </div>
            <div className="h-3 w-full bg-[#DC2626] rounded-full overflow-hidden flex" data-id="element-261">
              <div className="h-full bg-[#22C55E] transition-all duration-500 ease-out" style={{
              width: `${discountPct}%`
            }} data-id="element-262" />
            </div>
          </div>

          {/* Monthly Savings Highlight */}
          <div className="bg-gradient-to-br from-[#15803D] to-[#22C55E] rounded-xl p-6 text-center text-white shadow-lg mb-8" data-id="element-263">
            <p className="font-montserrat text-[13px] font-extrabold uppercase tracking-[2px] mb-2 opacity-90" data-id="element-264">
              Tu Ahorro Total Mensual
            </p>
            <p className="font-montserrat text-[48px] sm:text-[56px] font-black leading-none tracking-tight mb-2" data-id="element-265">
              <span className="text-2xl align-super opacity-80" data-id="element-266">$</span>
              {fmt(monthlySavings)}
            </p>
            <p className="text-[14px] opacity-90 font-medium" data-id="element-267">
              Fabricando {barsPerDay} barritas al día por {daysPerMonth} días
            </p>
          </div>

          {/* Ingredients Table */}
          <div data-id="element-268">
            <p className="font-montserrat text-[13px] font-bold text-[#0F172A] uppercase tracking-wide mb-3" data-id="element-269">
              Costo por Ingrediente (1 Barrita de 60g)
            </p>
            <div className="overflow-x-auto" data-id="element-270">
              <table className="w-full text-left border-collapse" data-id="element-271">
                <thead data-id="element-272">
                  <tr className="border-b-2 border-[#E2E8F0]" data-id="element-273">
                    <th className="py-3 px-2 text-[12px] font-bold text-[#64748B] uppercase tracking-wider" data-id="element-274">
                      Ingrediente
                    </th>
                    <th className="py-3 px-2 text-[12px] font-bold text-[#64748B] uppercase tracking-wider text-right" data-id="element-275">
                      Precio Super
                    </th>
                    <th className="py-3 px-2 text-[12px] font-bold text-[#64748B] uppercase tracking-wider text-right" data-id="element-276">
                      Tu Precio
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-277">
                  {INGREDIENTS.map((ing, idx) => {
                  const price = ing.basePrice * mult;
                  return <tr key={idx} className="border-b border-[#E2E8F0] last:border-0" data-id="element-278">
                        <td className="py-3 px-2 text-[14px] text-[#0F172A] font-medium" data-id="element-279">
                          {ing.name}{' '}
                          <span className="text-[#94A3B8] text-[12px]" data-id="element-280">
                            ({ing.qty}
                            {ing.unit})
                          </span>
                        </td>
                        <td className="py-3 px-2 text-[14px] text-[#94A3B8] text-right line-through" data-id="element-281">
                          ${fmt(ing.basePrice)}
                        </td>
                        <td className="py-3 px-2 text-right" data-id="element-282">
                          <span className="text-[14px] font-bold text-[#0F172A] mr-2" data-id="element-283">
                            ${fmt(price)}
                          </span>
                          {discountPct > 0 && <span className="inline-block bg-[#F0FDF4] text-[#15803D] text-[10px] font-bold px-1.5 py-0.5 rounded" data-id="element-284">
                              -{discountPct}%
                            </span>}
                        </td>
                      </tr>;
                })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>;
}